module.exports = __webpack_public_path__ + "static/get-app-7e0ff6c0e5987a7c0ed4dcf346506552.png";